import { buildWhatsappLink } from "~/helpers/routing";

export default function useCommunication() {
  const { phone, address, telegram, whatsappBot } = useBranch();
  const { branchEmailAddress: supportEmail } = useRouting();
  const whatsapp = whatsappBot || phone;
  const whatsappLink = buildWhatsappLink(whatsapp.raw);
  const addressText = address.text;

  return {
    phone, whatsapp, whatsappLink, telegram, supportEmail, addressText
  };
}